import { render, staticRenderFns } from "./OrderTypeTag.vue?vue&type=template&id=6ee03ada&scoped=true"
import script from "./OrderTypeTag.vue?vue&type=script&lang=js"
export * from "./OrderTypeTag.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeTag.vue?vue&type=style&index=0&id=6ee03ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee03ada",
  null
  
)

export default component.exports